import { DataSource, Layout, LayoutHeader, Table } from "@mcleod/components";

export abstract class AutogenLayoutDetentionDefaultsList extends Layout {
    layoutheaderDetentionDefaults: LayoutHeader;
    sourceDetentionProfile: DataSource;
    tableDetentionDefaults: Table;
}
